import { Identifier } from "../../core";
export class ProductCategoryId extends Identifier {
    constructor(id) {
        super("ProductCategoryId", id);
    }
}
